/* eslint-disable */
import getSSOBaseUrl from '../utils/environment'

export const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_MICROSOFT_CLIENT_ID || '',
    authority: `https://login.microsoftonline.com/${process.env.REACT_APP_MICROSOFT_TENANT_ID}`,
    redirectUri: getSSOBaseUrl(),
    postLogoutRedirectUri: getSSOBaseUrl(),
  },

  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: true, // good for Safari, Cloudflare, proxies
  },

  system: {
    allowRedirectInIframe: false,
    loggerOptions: {
      logLevel: 3,
      loggerCallback: () => {},
    },
  },
}

export const loginRequest = {
  // Request ID token (OIDC) plus Graph scope if needed
  scopes: ['openid', 'profile', 'email', 'User.Read'],
}
